module.exports = __webpack_public_path__ + "img/errorThumbnail@3_200x200.e4978bfc.png";